var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { MachineRegistrationBase } from "@/Common/types/internal/machineRegistrationBase";
var Registration = /** @class */ (function (_super) {
    __extends(Registration, _super);
    function Registration() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.machineInformation = null;
        _this.recaptchaResponse = null;
        _this.attachments = [];
        _this.nonce = null;
        _this.machineRegistrations = [];
        return _this;
    }
    return Registration;
}(MachineRegistrationBase));
export { Registration };
var MachineRegistrationSubmit = /** @class */ (function () {
    function MachineRegistrationSubmit() {
        this.machineRegistrations = [];
        this.registrationData = {};
        this.recaptchaResponse = null;
        this.nonce = null;
    }
    return MachineRegistrationSubmit;
}());
export { MachineRegistrationSubmit };
var MachineRegistartionPartialSubmit = /** @class */ (function () {
    function MachineRegistartionPartialSubmit() {
        this.machineRegistration = {};
        this.registrationData = {};
        this.nonce = null;
    }
    return MachineRegistartionPartialSubmit;
}());
export { MachineRegistartionPartialSubmit };
